import React from 'react';
const bonuses = [{
  num: '01',
  label: '🎁 BONO 1',
  title: 'Kit de Checklists Cero Errores',
  desc: 'Protocolo exacto para cada servicio. Nunca más improvises un trabajo. Incluye recepción, lavado, pulido y entrega profesional.',
  price: '$15.000'
}, {
  num: '02',
  label: '🎁 BONO 2',
  title: 'Presupuesto Pro + Condiciones',
  desc: 'Plantillas personalizables para enviar por WhatsApp. Cerrá más trabajos sin negociar precios ni perder tiempo.',
  price: '$12.000'
}, {
  num: '03',
  label: '🎁 BONO 3',
  title: 'Calculadora de Ganancia Detallada',
  desc: 'Calculá exactamente cuánto ganás por cada trabajo antes de arrancar. Incluye costos, insumos y tiempo.',
  price: '$10.000'
}, {
  num: '04',
  label: '🎁 BONO 4',
  title: 'Fotos Que Venden',
  desc: 'El sistema exacto para fotografiar antes y después. Cada foto trae tu próximo cliente. Potencia tu portafolio en redes.',
  price: '$10.000'
}];
export function Bonuses() {
  return <section className="w-full px-4 py-10 text-base leading-6" style={{
    backgroundColor: '#111111',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-41">
      <div className="mx-auto max-w-4xl" data-id="element-42">
        {/* Heading */}
        <div className="mb-6 text-center" data-id="element-43">
          <h2 className="text-3xl font-black leading-10 text-white m-0 mb-2" data-id="element-44">
            Más los <span className="text-yellow-400" data-id="element-45">4 Bonos Exclusivos</span>
          </h2>
          <p className="text-sm text-gray-400 m-0" data-id="element-46">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>

        {/* Bonus Cards Grid */}
        <div className="mb-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4" data-id="element-47">
          {bonuses.map(bonus => <div key={bonus.num} className="flex flex-col rounded-xl p-4 shadow-sm" style={{
          backgroundColor: 'rgba(234, 179, 8, 0.05)',
          border: '1px solid rgba(234, 179, 8, 0.3)'
        }} data-id="element-48">
              <div className="mb-1 text-2xl leading-8 font-black text-yellow-400" data-id="element-49">
                {bonus.num}
              </div>
              <div className="mb-1 text-[10px] font-bold uppercase tracking-[1.2px] text-yellow-400" data-id="element-50">
                {bonus.label}
              </div>
              <h3 className="text-sm font-black text-white m-0 mb-1" data-id="element-51">
                {bonus.title}
              </h3>
              <p className="flex-1 text-xs text-gray-400 m-0 mb-3" data-id="element-52">
                {bonus.desc}
              </p>
              <div className="flex items-center gap-2" data-id="element-53">
                <span className="text-xs text-gray-500 line-through" data-id="element-54">
                  {bonus.price}
                </span>
                <span className="bg-yellow-400 text-[10px] font-black text-gray-900 rounded-full px-2 py-0.5" data-id="element-55">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        {/* Total Value Footer */}
        <div className="mx-auto max-w-2xl text-center rounded-xl p-4 shadow-sm" style={{
        backgroundColor: 'rgba(234, 179, 8, 0.05)',
        border: '1px solid rgba(234, 179, 8, 0.3)'
      }} data-id="element-56">
          <p className="text-xs font-semibold uppercase tracking-[1.4px] text-yellow-400 m-0 mb-1" data-id="element-57">
            Valor total de los 4 Bonos
          </p>
          <div className="mb-1 flex flex-col sm:flex-row items-center justify-center gap-2" data-id="element-58">
            <span className="text-base text-gray-500 line-through" data-id="element-59">
              $47.000
            </span>
            <span className="text-base sm:text-xl font-black tracking-wide text-yellow-400" data-id="element-60">
              🎁 GRATIS — Incluidos siempre
            </span>
          </div>
          <p className="text-xs text-gray-400 m-0" data-id="element-61">
            Incluidos en todas las ofertas. Siempre.
          </p>
        </div>
      </div>
    </section>;
}